import './ReturnPackagePage.css'

import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useRef, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { usePackageFeesFromRequests } from '../../../api/package-req/hooks/usePackageFeesFromRequests'
import Tooltip from '../../../Components/Tooltip'
import applePayIcon from '../../../imgs/apple-pay.png'
import creditCardIcon from '../../../imgs/credit-card.png'
import googlePayIcon from '../../../imgs/google-pay.png'
import infoIcon from '../../../imgs/info.svg'
import returnIcon from '../../../imgs/right-arrow.png'
import uploadIcon from '../../../imgs/upload.svg'
import { QUERY_KEYS } from '../../../lib/queryKeys'
import { uploadFile } from '../../../services/files'
import { createPaymentLinkRP } from '../../../services/payments'
import PackageInfoCard from '../PackageInfoCard/PackageInfoCard'

export default function ReturnPackagePage() {
  const history = useHistory()
  const packageForReturn = useSelector(state => state.packages.packageForReturn)

  // Get fees from package requests instead of package entity
  const { data: packageFees } = usePackageFeesFromRequests(packageForReturn)
  //UI & terms
  const [showImgView, setshowImgView] = useState(false)
  const [showErrorModal, setshowErrorModal] = useState(false)
  const [errorModalText, seterrorModalText] = useState('')
  const [isLoadingSubmit, setisLoadingSubmit] = useState(false)
  const [isSafari, setisSafari] = useState(false)
  const queryClient = useQueryClient()
  //receipt data
  const [receiptFileURL, setreceiptFileURL] = useState()
  const [receiptFile, setreceiptFile] = useState()
  const [dotFileTypeState, setdotFileTypeState] = useState()

  const [paymentMethod, setPaymentMethod] = useState('creditCard')
  const [paymentUrl, setPaymentUrl] = useState(null)
  const [showInfoTooltip, setshowInfoTooltip] = useState(false)
  const infoTooltipRef = useRef(null)

  //in case of refresh. we want the user to start over.
  useEffect(() => {
    if (packageForReturn == null) {
      history.push(`/personal-info`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //detect browser
  useEffect(() => {
    // Get the user-agent string
    let userAgentString = navigator.userAgent
    // Detect Chrome
    let chromeAgent = userAgentString.indexOf('Chrome') > -1

    // Detect Safari
    let safariAgent = userAgentString.indexOf('Safari') > -1

    // Discard Safari since it also matches Chrome
    if (chromeAgent && safariAgent) safariAgent = false
    setisSafari(safariAgent)
  }, [])

  //Grow iFrame (meshulam)
  useEffect(() => {
    function iframeListener(result) {
      if (result.origin === 'https://secure.meshulam.co.il' || result.origin === 'https://sandbox.meshulam.co.il') {
        switch (result.data.action) {
          case 'close': {
            setPaymentUrl(null)
            break
          }
          case 'payment':
          case 'google_payment': {
            if (result.data.status == 1) {
              // success
              history.push('/rp-payment-successful')
              queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
            }
            break
          }
          case 'failed_to_load_page': {
            setPaymentUrl(null)
            seterrorModalText('הייתה שגיאה בבקשה. אנא נסה שנית או פנה לשירות הלקוחות.')
            setshowErrorModal(true)
            break
          }
        }
      }
    }
    window.addEventListener('message', result => iframeListener(result))
    return () => window.removeEventListener('message', iframeListener)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const receiptViewHandler = async e => {
    setshowImgView(false)
    document.getElementById('adobe-pdf-view').innerHTML = ''
    const file = e.target.files[0]
    if (!file) return

    //check for allowed files formats
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(file.type)) {
      seterrorModalText('ניתן להעלות תווית כתמונה או כPDF בלבד.')
      setshowErrorModal(true)
      return
    }

    setreceiptFile(file)
    let dotFileType = file.name
    dotFileType = dotFileType.substring(dotFileType.lastIndexOf('.'), dotFileType.length)
    setdotFileTypeState(dotFileType)

    // diffrent UI for image and PDF
    if (dotFileType !== '.pdf') {
      setreceiptFileURL(URL.createObjectURL(file))
      setshowImgView(true)
    } else {
      // Adobe API code (Adobe PDF Embed API)
      // eslint-disable-next-line no-undef
      var adobeDCView = new AdobeDC.View({ clientId: '3daf1a0430a045879e5bf8163cad53c3', divId: 'adobe-pdf-view' })
      var reader = new FileReader()
      reader.onloadend = function (e) {
        var filePromise = Promise.resolve(e.target.result)
        // Pass the filePromise and name of the file to the previewFile API
        adobeDCView.previewFile(
          {
            content: { promise: filePromise },
            metaData: { fileName: file.name },
          },
          { embedMode: 'IN_LINE' }
          // { defaultViewMode: 'SINGLE_PAGE' }
        )
      }
      reader.readAsArrayBuffer(file)
    }
  }

  const submitHandler = async () => {
    //check for allowed files formats
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(receiptFile.type)) {
      seterrorModalText('ניתן להעלות תווית כתמונה או כPDF בלבד.')
      setshowErrorModal(true)
      return
    }

    try {
      setisLoadingSubmit(true)
      //upload receipt to S3
      const result = await uploadFile(receiptFile, packageForReturn.id + dotFileTypeState)
      // console.log('submitHandler - params.updateParam.result.Location:', result.Location)

      //check if lable uploaded (not really needed but to make sure)
      if (!result.Location) throw 'link to label not found'

      //navigate to payment
      const paymentFormData = {
        pid: packageForReturn.id,
        paymentMethod,
        returnLabel: result.Location,
      }
      const paymentLink = await createPaymentLinkRP(paymentFormData)
      // console.log('submitHandler - paymentLink:', paymentLink)

      //apple wants new page
      if (paymentMethod == 'apple') window.location.href = paymentLink.data.data
      else setPaymentUrl(paymentLink.data.data)

      setisLoadingSubmit(false)
    } catch (error) {
      setisLoadingSubmit(false)
      console.log('Error: ', error)

      seterrorModalText('הייתה שגיאה בבקשה. אנא נסה שנית או פנה לשירות הלקוחות.')
      setshowErrorModal(true)
    }
  }

  const getFinalPrice = () => {
    const totalPrice =
      parseFloat(packageFees?.uniteFee ?? 0) +
      parseFloat(packageForReturn.delayChargePrice ?? 0) +
      parseFloat(packageForReturn.taxFreeFeeUSD ?? 0) +
      parseFloat(packageFees?.shrinkRequestFeeUSD ?? 0) +
      parseFloat(packageFees?.photoRequestFeeUSD ?? 0) +
      10 //return package fee
    return totalPrice.toFixed(2)
  }

  if (packageForReturn == null) {
    return <div></div>
  }

  return (
    <div className='rp-container'>
      {!paymentUrl ? (
        <>
          <div className='rp-top'>
            <div className='rp-return-cont' onClick={() => history.push('/personal-info/myPackages')}>
              <img src={returnIcon} className='rp-return-img' />
              <div>חזרה</div>
            </div>

            <div className='rp-page-title'>החזרת חבילה לספק</div>
            <div className='rp-page-description'>
              אנחנו נדאג להחזיר את החבילה לחנות-
              <br />
              פשוט העלה כאן את טופס ההחזרה וכל השאר עלינו!
            </div>
            <br />

            <PackageInfoCard item={packageForReturn} />

            {!receiptFile && (
              <div className='rp-page-upload-cont'>
                <div className='rp-page-upload-title'>העלאת תווית החזרה</div>
                <div
                  className='rp-page-upload-input'
                  onClick={() => {
                    document.getElementById(`receiptInput`).click()
                  }}
                >
                  <img src={uploadIcon} alt='upload' />
                  <div className='rp-page-upload-input-text-main'>גרור לכאן קובץ או לחץ לבחירה</div>
                  <div className='rp-page-upload-input-text-sub'>תמונה או PDF בלבד</div>
                </div>
                <div className='rp-page-upload-info' ref={infoTooltipRef} onClick={() => setshowInfoTooltip(true)}>
                  <img src={infoIcon} alt='info' />
                  מהי תווית החזרה?
                  <Tooltip
                    title=''
                    description='טופס החזרה הוא מסמך מהחנות שמאשר שקיבלת את המוצר ושהחזרתך מתקבלת. במידה ויש ברשותך לייבל (מדבקת שילוח)
                  לביצוע ההחזרה אנא צרף אותו. אחרת, אפשר לצרף צילום קבלה, טופס מיוחד מהאתר או כל מסמך אחר שהחנות שלחה לך.'
                    isTooltipOpen={showInfoTooltip}
                    setIsTooltipOpen={setshowInfoTooltip}
                    triggerRef={infoTooltipRef}
                    showTime={7000}
                  />
                </div>
              </div>
            )}
            <input type='file' id={'receiptInput'} style={{ display: 'none' }} onChange={receiptViewHandler} />

            {/* <div
              className="btn yellow-bcg"
              onClick={() => {
                document.getElementById(`receiptInput`).click()
              }}
            >
              {receiptFile ? 'תיקון תווית החזרה' : 'העלאת תווית החזרה'}
            </div> */}

            <div className='rp-file-view-cont'>
              {showImgView && <img src={receiptFileURL} alt='receipt-view' />}
              <div id='adobe-pdf-view' className='adobe-pdf-view'></div>
            </div>
          </div>

          {receiptFile && (
            <>
              <div className='rp-mid-cont'>
                <div className='rp-payment-method-cont'>
                  <div className='rp-subtitle'>אפשרויות תשלום</div>
                  <div className='rp-payment-method-choice'>
                    <input
                      type='radio'
                      id='pm-credit'
                      name='payment-method'
                      value='creditCard'
                      checked={paymentMethod === 'creditCard'}
                      onChange={() => setPaymentMethod('creditCard')}
                    />
                    <img src={creditCardIcon} alt='credit card' />
                    <div> - כרטיס אשראי</div>
                  </div>

                  <div className='rp-payment-method-choice'>
                    <input
                      type='radio'
                      id='pm-google'
                      name='payment-method'
                      value='google'
                      checked={paymentMethod === 'google'}
                      onChange={() => setPaymentMethod('google')}
                    />
                    <img src={googlePayIcon} alt='Google Pay' />
                    <div> - Google Pay</div>
                  </div>

                  {isSafari && (
                    <div className='rp-payment-method-choice'>
                      <input
                        type='radio'
                        id='pm-apple'
                        name='payment-method'
                        value='apple'
                        checked={paymentMethod === 'apple'}
                        onChange={() => setPaymentMethod('apple')}
                      />
                      <img src={applePayIcon} alt='Apple Pay' />
                      <div> - Apple Pay</div>
                    </div>
                  )}
                </div>

                <div className='rp-sum-cont'>
                  <h4 className='rp-subtitle' style={{ textAlign: 'center' }}>
                    סיכום
                  </h4>

                  <div className='rp-sum-row'>
                    <span>עמלת החזרת חבילה:</span> <span>10$</span>
                  </div>
                  {packageFees?.uniteFee > 0 && (
                    <div className='rp-sum-row'>
                      <span>תוספת בגין איחוד חבילות: </span> <span>{packageFees.uniteFee}$</span>
                    </div>
                  )}
                  {packageForReturn.delayChargePrice > 0 && (
                    <div className='rp-sum-row'>
                      <span>דמי אחסון: </span> <span>{packageForReturn.delayChargePrice}$</span>
                    </div>
                  )}
                  {packageForReturn.taxFreeFeeUSD > 0 && (
                    <div className='rp-sum-row'>
                      <span>עלות העברה מדלוואר: </span> <span>{packageForReturn.taxFreeFeeUSD}$</span>
                    </div>
                  )}
                  {packageFees?.photoRequestFeeUSD > 0 && (
                    <div className='rp-sum-row'>
                      <span>עמלת צילום חבילה:</span> <span>{packageFees.photoRequestFeeUSD}$</span>
                    </div>
                  )}
                  {packageFees?.shrinkRequestFeeUSD > 0 && (
                    <div className='rp-sum-row'>
                      <span>עמלת צמצום חבילה: </span> <span>{packageFees.shrinkRequestFeeUSD}$</span>
                    </div>
                  )}

                  <div className='rp-sum-row rp-sum-last'>
                    <span>סה"כ:</span> <span>{getFinalPrice()}$</span>
                  </div>
                </div>
              </div>

              <div className='rp-bottom-cont'>
                {/* <div className="rp-page-badge">
                  השירות כרוך בתשלום מיידי של $10 ולפי תנאי הספק בלבד
                </div> */}
                <div style={{ height: '100px' }}>
                  {isLoadingSubmit ? (
                    <Spinner animation='border' variant='primary' />
                  ) : (
                    <>
                      <Button block disabled={isLoadingSubmit} onClick={submitHandler} variant='primary' style={{ width: '226px' }}>
                        לתשלום והחזרה
                      </Button>
                      <br />
                      <div className='reject-button' onClick={() => history.push('/personal-info/myPackages')}>
                        לא עכשיו
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <div className='rp-payment-iframe-cont'>
          <div className='rp-payment-iframe-cont1'>
            <iframe
              src={paymentUrl}
              height='625'
              width='100%'
              title='Grow payment iframe'
              style={{ border: 'none' }}
              allow='payment'
            ></iframe>
          </div>
        </div>
      )}

      <Modal show={showErrorModal} onHide={() => setshowErrorModal(false)} style={{ direction: 'rtl', textAlign: 'center' }}>
        <Modal.Header style={{ textAlign: 'center' }}>
          <div style={{ width: '100%' }}>
            <Modal.Title>שים לב!</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>{errorModalText}</Modal.Body>
        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Button variant='danger' onClick={() => setshowErrorModal(false)}>
            סגור
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
